import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface BusinessArea {
    id: number;
    code: string;
    name?: string;
}

export async function getBusinessArea(id: number): Promise<BusinessArea> {
    return legacyFetch<BusinessArea>(`businessareas/${id}`);
}

export async function createBusinessArea(ba: Partial<BusinessArea>): Promise<BusinessArea> {
    return legacyFetch<BusinessArea>('businessareas', {
        method: 'POST',
        body: JSON.stringify(ba),
    });
}

export async function updateBusinessArea(ba: BusinessArea): Promise<BusinessArea> {
    return legacyFetch<BusinessArea>(`businessareas`, {
        method: 'PUT',
        body: JSON.stringify(ba),
    });
}

export async function deleteBusinessArea(id: number): Promise<void> {
    await legacyFetch<void>(`businessareas/${id}`, { method: 'DELETE' });
}
